export default function check(uqn) {
    let type, biggest, compare, choices;
    type = Number(uqn.toString()[0]);
    biggest = Number(uqn.toString()[1]);
    compare = Number(uqn.toString()[2]);
    choices = Number(uqn.toString()[3]);
    if (type < 1 || type > 3) {
        return false;
    }
    if (biggest < 4 || biggest > 6) {
        return false;
    }
    if (type == 1) {
        if (choices != 0) {
            return false;
        }
        if (compare < 2 || compare > biggest - 1) {
            return false;
        }
    }
    else {
        if (choices < biggest + 1) {
            return false;
        }
        if (compare < 2 || compare > choices - 1) {
            return false;
        }
    }
    return true;
}
